export const socialList = ['google', 'facebook', 'tiktok'];
